import { render, staticRenderFns } from "./DeletePricingModal.vue?vue&type=template&id=24582f6c&scoped=true"
import script from "./DeletePricingModal.vue?vue&type=script&lang=js"
export * from "./DeletePricingModal.vue?vue&type=script&lang=js"
import style0 from "./DeletePricingModal.vue?vue&type=style&index=0&id=24582f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24582f6c",
  null
  
)

export default component.exports